export default __webpack_public_path__ + "static/media/size_chart.6d447303.png";